import React from 'react';
import {MultiTenantGridView} from '../leftView/MultiTenantGridView';
import {StyleSheet, View} from 'react-native';

export const MultiTenantCenterViewWithGrid = () => {
  return (
    <View style={styles.mainStack}>
      <MultiTenantGridView fullScreen={true} />
    </View>
  );
};

const styles = StyleSheet.create({
  mainStack: {
    flex: 1,
  },
});
